import { ITeamLastNextMatch } from "@sky-it-livedata/livedata-sports-design-system";
import { LastAndNextMatchQuery } from "../types";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { intcmpMap } from "../../../utils/intcmp";
import { CreateLastAndNextMatchInputSchema } from "appsync";
import { isValidTeamLastNextMatch} from "./typeguards";


const transformer = (obj: LastAndNextMatchQuery): ITeamLastNextMatch => {

  if (isValidTeamLastNextMatch(obj)) {
    CreateLastAndNextMatchInputSchema().parse(obj.data?.getLastAndNextMatch, {
      reportInput: true,
    });

    const { updatedAt, createdAt, ...getLastAndNextMatch } = obj?.data?.getLastAndNextMatch;

    return {
      ...getLastAndNextMatch,
      nextMatch: obj.data.getLastAndNextMatch?.nextMatch ?{
        ...obj.data.getLastAndNextMatch?.nextMatch,
        liveOnSky: obj.data.getLastAndNextMatch.nextMatch?.liveOnSky ?? undefined,
      }: null,
      lastMatch: obj.data.getLastAndNextMatch?.lastMatch ?{
        ...obj.data.getLastAndNextMatch?.lastMatch,
        liveOnSky: obj.data.getLastAndNextMatch.lastMatch?.liveOnSky ?? undefined,
      }: null,
      isLoading: false,
      customTrackingData: intcmpMap.teamLastNextMatch,
    } as ITeamLastNextMatch;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message:
        "Invalid transformer input, Error in TeamLastNextMatchQuery object",
      data: obj,
    });
  }
};

export default transformer;
